import React from 'react';
import CancelledEula from './cancelled-eula';
import AcceptableEula from './acceptable-eula';
import './styles/index.scss';
const defaultCancelEulaModalProps: Partial<CMxCommonApp.ModalProps> = {
  closable: false,
  forceSubmitOptions: {
    isForced: false,
    message: 'Returning to the login screen',
    time: 10
  },
  buttonText: ''
};

const Eula: React.FC<CMxCommonApp.EulaComponentProps> = props => {
  const { isCancelled, onEulaCancel } = props;

  if (!isCancelled) {
    return <AcceptableEula {...props} />;
  } else {
    return (
      <CancelledEula
        onEulaCancel={onEulaCancel}
        modalProps={defaultCancelEulaModalProps}
      />
    );
  }
};
Eula.displayName = 'Eula';

export { Eula };
